import { render, staticRenderFns } from "./ViewEvaluationGrade.vue?vue&type=template&id=5caa71ff&scoped=true"
import script from "./ViewEvaluationGrade.vue?vue&type=script&lang=js"
export * from "./ViewEvaluationGrade.vue?vue&type=script&lang=js"
import style0 from "./ViewEvaluationGrade.vue?vue&type=style&index=0&id=5caa71ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa71ff",
  null
  
)

export default component.exports